import { apiClient } from "@/services/api";
import { useQuery } from "@tanstack/react-query";

export const accountKeys = {
  all: ["accounts"] as const,
  list: () => [...accountKeys.all, "list"] as const,
  detail: (id: number) => ["account", id] as const,
  interestRateHistory: (id: number) => ["interest-rate-history", id] as const,
};

export function useAccounts() {
  return useQuery({
    queryKey: accountKeys.list(),
    queryFn: () => apiClient.getAccounts(),
  });
}
